import styled from 'styled-components';

import { basicSmallTextStyle, Text } from '@dreryk/react-components';

export const StyledHealthcareTreeItemText = styled(Text)`
   ${basicSmallTextStyle}
`;

StyledHealthcareTreeItemText.displayName = 'StyledHealthcareTreeItemText';
